import { Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "./Screens/Admin/Dashboard";
import Adduser from "./Screens/Admin/Adduser";
import Addrate from "./Screens/ShopOwner/Addrate";
import Preview from "./Screens/ShopOwner/Preview";
import Screen from "./Screens/Screen";
import Login from "./Screens/Login";
import Shop_Details from "./Screens/Admin/Shop_detail";
import { useEffect, useState } from "react";

const App = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const getJWTPayload = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const json = atob(base64);
      return JSON.parse(json);
    } catch (e) {
      console.error("Invalid JWT:", e);
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Token:", token);

    if (token) {
      const payload = getJWTPayload(token);
      console.log(payload);
      if (payload && payload.user) {
        localStorage.setItem("user", JSON.stringify(payload.user));
        setIsAuthenticated(true);
        const role = payload.type;

        console.log("User role:", role);

        if (role === "screen") navigate("/screen");
        else if (role === "admin") navigate("/dashboard");
        else navigate("/addRate");
      } else {
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, []);

  // if (!isAuthenticated && window.location.pathname !== "/login") return null;

  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="login" element={<Login />} />
      <Route path="adduser" element={<Adduser />} />
      <Route path="addrate" element={<Addrate />} />
      <Route path="preview" element={<Preview />} />
      <Route path="screen" element={<Screen />} />
      <Route path="shop" element={<Shop_Details />} />
    </Routes>
  );
};

export default App;
